module.exports = __webpack_public_path__ + "static/media/CTLI_9-391w.a51bafad.jpg";